import View from 'mixins/view';
import CoverCalendarView from 'ui/cover/cover-calendar-view';
import moment from 'moment/moment';

export const elements = {
    container: '.covers-heading',
    titleDay: '.covers-heading h5 span',
    trigger: '.covers-trigger',
    calendarHolder: '.covers-calendarHolder',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(elements.container));
        model.addEventListener('changedDay', this.updateHeader.bind(this));
        this.isCalendarExpanded = false;
    }
    updateHeader() {
        this.title.html('z ' + moment(this.model.get('currentDay')).format('D MMMM YYYY'));
    }
    collapseCalendar() {
        $(elements.calendarHolder, this.rootEl)
          .toggleClass(`${elements.calendarHolder.substr(1)}__visible`);
        const strong = this.holder.find('.covers-trigger-text');
        const label = (this.isCalendarExpanded)
            ? strong.data('caption-collapsed')
            : strong.data('caption-expanded');

        this.isCalendarExpanded = !this.isCalendarExpanded;
        strong.html(label);
    }
    render() {
        this.title = $(elements.titleDay);
        this.holder = $(elements.trigger);
        this.holder.removeClass('fn-hidden');

        this.calendar = new CoverCalendarView(this.model);
        this.calendar.render();

        this.holder.click(this.collapseCalendar.bind(this));

    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/cover/cover-heading-view.js